var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tags', _vm.size, { ellipsis: _vm.ellipsis }]},_vm._l((_vm.list),function(tag){return _c('a-tag',{key:tag.value,staticClass:"tags__item",on:{"click":function($event){return _vm.onClick($event, tag)}}},[_vm._v(" "+_vm._s(tag.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }